import { render, staticRenderFns } from "./Roles.vue?vue&type=template&id=7392f4aa&scoped=true"
import script from "./Roles.vue?vue&type=script&lang=js"
export * from "./Roles.vue?vue&type=script&lang=js"
import style0 from "./Roles.vue?vue&type=style&index=0&id=7392f4aa&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7392f4aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7392f4aa')) {
      api.createRecord('7392f4aa', component.options)
    } else {
      api.reload('7392f4aa', component.options)
    }
    module.hot.accept("./Roles.vue?vue&type=template&id=7392f4aa&scoped=true", function () {
      api.rerender('7392f4aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/organizacion/usuario/Roles.vue"
export default component.exports